// extracted by mini-css-extract-plugin
module.exports = {"container":"bugs_container__3MHzA","crash":"bugs_crash__25wFx"};